import { Grid, makeStyles, Typography } from 'beam'
import { FC, isValidElement, ReactNode, ReactNodeArray } from 'react'
import Description from './Description'

const useStyles = makeStyles(theme => ({
  header: {
    padding: theme.spacing(2),
    width: '100%',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}))

export interface HeaderProps {
  /** form action buttons */
  buttons?: ReactNodeArray,
  /** Title of the form */
  title?: string,
  /** If the description is a string, we render it in a description node, otherwise you can pass something custom */
  description?: ReactNode,
}

const Header: FC<HeaderProps> = ({ title = '', description = '', buttons = [] }) => {
  const classes = useStyles()
  return (
    <Grid container className={classes.header}>
      <Grid item xs={12}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h4">{title}</Typography>
          </Grid>
          <Grid item>
            <Grid container data-testid="AdminFormHeader-ButtonList">
              {buttons.map((button, i) => (
                <Grid item key={i}>
                  {button}
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {description && isValidElement(description) && description}
      {description && typeof description === 'string' && <Description description={description} />}
    </Grid>
  )
}

export default Header
